<template>

    <div>
    <div v-if="mdList.length > 0 "> 
         <div v-show="!sign"  style="text-align: left;margin-left: 5rem">
            <div v-for="(item,index,key) in mdList" :key="key" >
                <a  @click="goto(item)">{{item}}</a>
            </div>
        </div>
        <ResultDetail ref="son" v-show="sign"></ResultDetail>
    </div>

          <el-divider v-if="mdList.length == 0 "  content-position="center">暂无数据</el-divider>
    </div>
    

</template>

<script>
    import { ajax } from "@/network/request";
    import ResultDetail from '@/components/ResultDetail.vue'
    export default {
        name: "Result",
        data(){
            return{
                mdList:[],
                sign:false
            }
        },
        created() {
            this.sign = false
            // this.getData(this.$route.params.name);
        },
        components:{
            ResultDetail
        },
        methods: {
            setSign(sign){
              this.sign = sign;
            },
            getData(name) {
                ajax({
                    url: "/helper/queryList",
                    method: "POST",
                    baseURL: "/hehe",
                    data: {
                        name: name
                    }
                }).then(res => {
                    console.log(res);
                    if(res.data == null || res.data.length == 0){
                        this.mdList.length = 0;
                        this.mdList.push(this.title);
                    }else{
                        this.mdList = res.data;
                        if(this.mdList.length == 1){
                            this.goto(this.mdList[0]);
                        }
                    }
                });
            },
            goto(name){
                // if(name == this.title){
                //     return;
                // }
                this.sign = true;
                this.$refs.son.getData(name);
                //  name = this.path + '/' + name
                // this.$router.replace({name:'ResultDetail',params: {name:this.path,path:name}})
            }
        },
        beforeRouteUpdate(to, from, next) {

            this.path = to.params.name;
            this.getData(this.path);
            next();
        },
    }
</script>

<style scoped lang="scss">
    a{
        cursor: pointer;
        font-size: 20px;
    }

    div{
        margin-top: 1rem;
    }
</style>